import { render } from "./DashboardVideo.vue?vue&type=template&id=9f1545f0&scoped=true&ts=true"
import script from "./DashboardVideo.vue?vue&type=script&lang=ts"
export * from "./DashboardVideo.vue?vue&type=script&lang=ts"

import "./DashboardVideo.vue?vue&type=style&index=0&id=9f1545f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1545f0"]])

export default __exports__